interface MiniInfoCircleIconProps {
  color?: string;
}

export default function MiniInfoCircleIcon({ color = '#3B4567' }: MiniInfoCircleIconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00016 14.6693C11.6668 14.6693 14.6668 11.6693 14.6668 8.0026C14.6668 4.33594 11.6668 1.33594 8.00016 1.33594C4.3335 1.33594 1.3335 4.33594 1.3335 8.0026C1.3335 11.6693 4.3335 14.6693 8.00016 14.6693Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99854 11.3359L7.99854 8.0026"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00244 6L7.99645 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
